//import {USER_SET_LOGIN_DATA, USER_SET_MBAUTH_DATA, USER_LOGOUT} from '../constants/actionTypes';
import {USER_LOGIN, USER_SET_AGENT, APP_CLEAR, APP_ERROR} from '../constants/actionTypes';
import {fetchMB, setAuthData, clearAuthData, getApiUserName} from '../utils/MojBus'

//
//export function setLoginData(loginData) {
//  return {
//    type: USER_SET_LOGIN_DATA,
//    loginData
//  }
//}
//export function setApiData(apiData) {
//  return {
//    type: USER_SET_MBAUTH_DATA,
//    apiData
//  }
//}

export function login(loginData){
  return {
    type: USER_LOGIN,
    loginData
  }
}

export function logout(){
  return {
    type: APP_CLEAR
  }
}

export function errorDesc(desc){
  alert(desc)
  return {
    type: APP_ERROR,
    errorDesc: desc
  }
}
export function error(errorNo){
  var desc="Błąd: " + errorNo
  return errorDesc(desc)
}

export function setAgent(newAgentLogin){
  return {
    type: USER_SET_AGENT,
    agentLogin: newAgentLogin
  }
}

export function fetchLogin(loginData){
//  console.log('Fetch login')
  const apiLogin={
    user: loginData.username,
    password: loginData.password
  }

  return dispatch => {
    let funcError=function(error){
      return dispatch(logout())
    }

    fetchMB('login', apiLogin, false)
    .then(
      function(json){
        if (json.status==='OK'){
          let loginData={
            userLogin: apiLogin.user,
            userName: json.fullName,
            apiUser:json.apiUser,
            agentName: '',
            agentLogin: '',
            agents: json.agents,
          }

          if (json.hasOwnProperty('agents')){
            let agents=json.agents
            if (agents.length>0){
              loginData={
                ...loginData,
                agents,
                agentLogin: agents[0].LoginName,
                agentName: agents[0].ShortName,
                agentCompanies: agents[0].Companies
              }
            }
          }
          setAuthData(json.apiUser, json.apiKey)
          //test
//          const apiSearch={
//            departureDate: '2017-07-22',
//          }
//
//          fetchMB('courses', apiSearch, true)
//          .then(
//            function(jSearch){
//              console.log('Search', jSearch)
//            },
//            function(error){
//              console.log('Error', error)
//            }
//          )
          //--test

//          dispatch(setLoginData(loginData))
//          return dispatch(setApiData(apiData))
          return dispatch(login(loginData))
        }
        else
          funcError()
      },
      funcError
    )
  }
}


export function fetchLogout(){
  const apiLogout={
    user: getApiUserName(),
  }
  return dispatch => {
    let funcError=function(error){
      return dispatch(logout())
    }

    fetchMB('logout', apiLogout, false)
    .then(
      function(json){
        if (json.status==='OK'){
          clearAuthData()
          return dispatch(logout())
        }
        else
          funcError()
      },
      funcError
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js